// firebase.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBjfm1xt-HcZUeuiU05Z4TFrZ64agCqK0s",
  authDomain: "goodweeks--tourism.firebaseapp.com",
  projectId: "goodweeks--tourism",
  storageBucket: "goodweeks--tourism.firebasestorage.app",
  messagingSenderId: "235287746042",
  appId: "1:235287746042:web:5217ec5efe8273235dc043",
  measurementId: "G-EB27PHRLWM"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// export const generateFcmToken = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission !== "granted") return null;

//     const token = await getToken(messaging, {
//       vapidKey: "BI_7wFX0-P45sVIUAjdc1xZxYYknSYilECKWuZgV5QtbswXeIQh866o6FCMpUfB6fVERCX1fkuDMxqHMAfbJcGg",
//     });

//     return token;
//   } catch (err) {
//     return null;
//   }
// };

export const generateFcmToken = async (): Promise<string | null> => {
  try {
    if (Notification.permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });

    return token || null;
  } catch (err) {
    console.error("FCM token error:", err);
    return null;
  }
};
